// Alert routing's pages (owner 2026-10-30): separate sidebar pages, like every
// other staff area, never one page with tabs. Under "Alerts & email": Alert
// routes, Alert targets, Alert connections and Alert runs; under "Sign-in &
// SSO": SSO alert coverage. A record opens over its page: a target, a
// connection and a run as drawers, a route in its editor.
export const ROUTES_PAGE = '/admin/alert-routing/routes'
export const TARGETS_PAGE = '/admin/alert-routing/targets'
export const CONNECTIONS_PAGE = '/admin/alert-routing/connections'
export const RUNS_PAGE = '/admin/alert-routing/runs'
export const SSO_COVERAGE_PAGE = '/admin/sso/alert-coverage'

export const NEW_TARGET = `${TARGETS_PAGE}/new`

export const routeHref = id => `${ROUTES_PAGE}/${id}`
export const targetHref = id => `${TARGETS_PAGE}/${id}`
export const connectionHref = id => `${CONNECTIONS_PAGE}/${id}`
export const runHref = id => `${RUNS_PAGE}/${id}`
// A new target: its first step ("What kind of target?"), or straight at its
// form when the type is known.
export const newTargetHref = type => (type ? `${NEW_TARGET}?type=${encodeURIComponent(type)}` : NEW_TARGET)
// The routes of one category (the Errors page's "Error alert routes").
export const routesHref = category => (category ? `${ROUTES_PAGE}?category=${encodeURIComponent(category)}` : ROUTES_PAGE)
// The alerts about one subject (an error group's "Every alert for this error").
export const runsHref = subjectRef => (subjectRef ? `${RUNS_PAGE}?subjectRef=${encodeURIComponent(subjectRef)}` : RUNS_PAGE)

// The alerts sent to one target (a target's "View all in run history").
export const runsForTarget = id => `${RUNS_PAGE}?targetID=${encodeURIComponent(id)}`

const OLD_TABS = { routes: ROUTES_PAGE, targets: TARGETS_PAGE, runs: RUNS_PAGE, sso: SSO_COVERAGE_PAGE }

// The old one-page address (/admin/alert-routing?tab=...: links in mails, the
// other pages' links, bookmarks) as its page's address. No tab was Routes.
// The rest of the query goes along (category, subjectRef), except to SSO
// alert coverage, which reads none.
export const pageOfOldAddress = search => {
  const q = new URLSearchParams(search)
  const page = OLD_TABS[q.get('tab')] || ROUTES_PAGE
  q.delete('tab')
  const rest = page === SSO_COVERAGE_PAGE ? '' : q.toString()
  return rest ? `${page}?${rest}` : page
}
